import React, { useState, useRef, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';
import { useTheme } from '../context/ThemeContext';
import { useMobileMenu } from '../context/MobileMenuContext';

const MobileStickyBar = () => {
  const { language, changeLanguage } = useLanguage();
  const { theme, toggleTheme } = useTheme();
  const { closeMobileMenu } = useMobileMenu();
  const location = useLocation();
  const [isLangOpen, setIsLangOpen] = useState(false);
  const dropdownRef = useRef(null);

  const languages = [
    { code: 'en', label: 'EN', fullName: 'English' },
    { code: 'bm', label: 'BM', fullName: 'Bahasa Malaysia' },
    { code: 'zh', label: '华语', fullName: '中文' }
  ];

  const currentLang = languages.find(lang => lang.code === language) || languages[0];

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsLangOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleLanguageSelect = (langCode) => {
    changeLanguage(langCode);
    setIsLangOpen(false);
  };

  // Get current path without language prefix for home link
  const getHomePath = () => {
    return `/${language}`;
  };

  return (
    <div className="mobile-sticky-bar">
      {/* Home Icon */}
      <Link 
        to={getHomePath()} 
        className="mobile-sticky-btn"
        aria-label="Home"
        onClick={closeMobileMenu}
      >
        <i className="fas fa-home"></i>
      </Link>

      {/* Contact Icon */}
      <Link 
        to={`/${language}/contact#information`} 
        className="mobile-sticky-btn"
        aria-label="Contact Us"
        onClick={closeMobileMenu}
      >
        <i className="fas fa-map-marker-alt"></i>
      </Link>

      {/* Language Switcher */}
      <div className="mobile-sticky-lang-switcher" ref={dropdownRef}>
        <button
          className="mobile-sticky-btn"
          onClick={() => setIsLangOpen(!isLangOpen)}
          aria-label="Select Language"
          aria-expanded={isLangOpen}
        >
          <i className="fas fa-globe"></i>
        </button>

        {isLangOpen && (
          <div className="mobile-sticky-lang-dropdown">
            <div className="mobile-sticky-lang-dropdown-inner">
              {languages.map((lang) => (
                <button
                  key={lang.code}
                  className={`mobile-sticky-lang-option ${language === lang.code ? 'active' : ''}`}
                  onClick={() => handleLanguageSelect(lang.code)}
                >
                  <span className="mobile-sticky-lang-code">{lang.label}</span>
                  <span className="mobile-sticky-lang-name">{lang.fullName}</span>
                  {language === lang.code && <i className="fas fa-check"></i>}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>

      {/* Theme Toggle */}
      <button 
        className="mobile-sticky-btn mobile-sticky-theme-toggle"
        onClick={toggleTheme}
        aria-label="Toggle theme"
      >
        <i className={`fa-regular fa-${theme === 'light' ? 'moon' : 'lightbulb'}`}></i>
      </button>
    </div>
  );
};

export default MobileStickyBar;
